/**
 * Иконки этапов случая карантина (agroai-0e8) — ОДНИ на верхнюю шкалу
 * раскрытия строки и на журнал «Полное дело контура»: лупа — находка,
 * документ — предписание, трактор — работы хозяйства, линейка — замер
 * инспектора, щит — решение.
 */
import { FileText, Ruler, Search, ShieldCheck, Tractor, type LucideIcon } from 'lucide-react';
import type { Stage } from './prescriptionsModel';

export const STAGE_ICON: Record<Stage, LucideIcon> = {
  finding: Search,
  requirement: FileText,
  report: Tractor,
  followup: Ruler,
  resolved: ShieldCheck,
};
